import krryPaging from './Index.vue';
export default krryPaging;